var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import SelectFieldAsync from "./SelectFieldAsync";
function isSelectedItemProps(x) {
    return "selectedItem" in x;
}
function isValueProps(x) {
    return "value" in x;
}
var SelectFieldSync = function (props) {
    var _a, _b;
    var handleLegacyOnChange = React.useCallback(function (value) {
        var _a;
        if (!value) {
            props.onChange(null);
        }
        var item = (_a = props.items.find(function (item) { return item.value === value; })) !== null && _a !== void 0 ? _a : null;
        props.onChange(item);
    }, [props.items, props.onChange]);
    if (isValueProps(props)) {
        return React.createElement(CoreSelectField, __assign({}, props));
    }
    else if (isSelectedItemProps(props)) {
        return (React.createElement(CoreSelectField, __assign({}, props, { value: (_b = (_a = props.selectedItem) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null, onChange: handleLegacyOnChange })));
    }
    else {
        throw new Error("Missing properties from SelectField: value, onChange");
    }
};
export default SelectFieldSync;
var CoreSelectField = function (props) {
    var items = props.items, onChange = props.onChange, value = props.value, _a = props.searchFilter, searchFilter = _a === void 0 ? caseInsensitiveContains : _a, rest = __rest(props, ["items", "onChange", "value", "searchFilter"]);
    var itemValue = React.useMemo(function () { var _a; return (_a = items.find(function (item) { return item.value === value; })) !== null && _a !== void 0 ? _a : null; }, [items, value]);
    var handleRequestItems = React.useCallback(function (query) {
        return Promise.resolve(getFilteredItems(items, query, searchFilter));
    }, [items, searchFilter]);
    var handleOnChange = React.useCallback(function (item) {
        if (!item) {
            onChange(null);
        }
        else {
            onChange(item.value);
        }
    }, [onChange]);
    return (React.createElement(SelectFieldAsync, __assign({}, rest, { onRequestItems: handleRequestItems, value: itemValue, onChange: handleOnChange })));
};
function caseInsensitiveContains(value, searchText) {
    searchText = searchText.trim().toLowerCase();
    return value.toLowerCase().indexOf(searchText) !== -1;
}
function getFilteredItems(items, filter, searchFilter) {
    if (!filter || filter === "") {
        return items;
    }
    return items.filter(function (item) { return searchFilter(itemToString(item), filter); });
}
function itemToString(item) {
    var _a;
    if (!item) {
        return "";
    }
    return (_a = item.label) !== null && _a !== void 0 ? _a : String(item.value);
}
//# sourceMappingURL=SelectFieldSync.js.map